module.exports = __webpack_public_path__ + "media/images/social-share-button/email-8ab2c0b6502cac7b7d72af4dc0c6d366.svg";